module.exports = __webpack_public_path__ + "img/banner01_h5.ff8eee07.jpg";